export default "__VITE_ASSET__svyaJLgs__"